import { makeAutoObservable, runInAction } from "mobx";
import { backend_url } from "./constants";
import { useApi } from "./auth";
import { useState } from "react";

export class ResultStore {
  runObject = null;
  endpointObject = null;
  bmdObject = null;
  experimentObject = null; 
  loading = false;
  allLoaded = false;
  error = null;

  constructor(apiFetch) {
    this.apiFetch = apiFetch
    makeAutoObservable(this);
  }

  async fetchRun(uuid) {
    if (this.loading) return;
    console.log("fetch run");
    this.loading = true;
    this.error = null;
    try {
      const res = await this.apiFetch(backend_url + `/api/get-dt-run/${uuid}/`)
      const runObject = await res.json();
      runInAction(() => {        
        if(res.status==200){
          this.runObject = runObject;
          this.fetchRelatedObjects();
        }
        else{
          this.runObject = null;
        }
      });
    } catch (e) {
      runInAction(() => {
        this.error = e;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async fetchRelatedObjects(){
    console.log("fetch related");
    this.fetchEndpoints();
    this.fetchBMDs();
    this.fetchExperiment();
  }

  async fetchEndpoints() {

    try {
      const res = await this.apiFetch(backend_url + `/api/get-dt-sensitivity/${this.runObject.uuid}/`)
      const endpointObject = await res.json();

      runInAction(() => {
        this.endpointObject = endpointObject;
        if (!endpointObject.has_executed) {
            let fetchFunc = this.fetchEndpoints.bind(this)
            window.setTimeout(fetchFunc, 5000);
          }
      });
    } catch (e) {
      runInAction(() => {
        this.error = e;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async fetchBMDs() {
    try {
      const res = await this.apiFetch(backend_url + `/api/get-dt-bmd/${this.runObject.uuid}/`)
      const bmdObject = await res.json();

      runInAction(() => {
        this.bmdObject = bmdObject;
        if (!bmdObject.has_executed) {
            let fetchFunc = this.fetchBMDs.bind(this)
            window.setTimeout(fetchFunc, 5000);
          }
      });
    } catch (e) {
      runInAction(() => {
        this.error = e;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
  async fetchExperiment() {

    try {
      const res = await this.apiFetch(backend_url + `/api/get-dt-design/${this.runObject.uuid}/`)
      const experimentObject = await res.json();

      runInAction(() => {
        this.experimentObject = experimentObject;
        if (!experimentObject.has_executed) {
            let fetchFunc = this.fetchExperiment.bind(this)
            window.setTimeout(fetchFunc, 5000);
          }
      });
    } catch (e) {
      runInAction(() => {
        this.error = e;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  
}
export function useResultStore() {
  const { apiFetch } = useApi();

  const [store] = useState(() => new ResultStore(apiFetch));
  return store;
}


